import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  comboBoxRoot: {
    width: 250,
    height: 35,
    backgroundColor: '#fff',
  },
  filterSize: {
    width: 150,
  },
}));

const NewAutoComplete = (props) => {
  const {
    list = [],
    label = 'NewAutoComplete',
    name = 'NewAutoComplete',
    valueKey,
    labelKey,
    getParam = (f) => f,
    params,
    allValue = null,
    alertMessage = undefined,
    type = 'filter',
    className,
    ...rest
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const initValue = params[name] === undefined ? null : params[name];
  const [value, setValue] = useState(initValue);
  const [inputValue, setInputValue] = useState('');

  const usePrevious = (value) => {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  };
  const prevList = usePrevious(list);

  useEffect(() => {
    let newList = [];
    if (JSON.stringify(prevList) !== JSON.stringify(list)) {
      for (let val of list) {
        if (!!val[valueKey]) {
          newList.push(val[valueKey]);
        }
      }
      setOptions(newList);
    }
    // eslint-disable-next-line
  }, [list]);

  useEffect(() => {
    if (!!params[name] === false) {
      handleReset();
    } // eslint-disable-next-line
  }, [params[name]]);

  useEffect(() => {
    if (!!value) {
      getParam(
        {
          ...params,
          [name]: value,
        },
        name
      );
    } else {
      getParam(
        {
          ...params,
          [name]: allValue,
        },
        name
      );
    }
    // eslint-disable-next-line
  }, [value]);

  const handleReset = () => {
    setValue(initValue);
    setInputValue('');
  };

  const handleOnChange = (newValue) => {
    setValue(newValue);
  };
  const handleOnInputChange = (newInputValue) => {
    setInputValue(newInputValue);
  };
  const handleOnClose = (reason) => {
    if (reason === 'blur') {
      if (inputValue !== '' && !options.includes(inputValue)) {
        handleClickSnackbar({
          message: !!alertMessage
            ? alertMessage
            : t('자동완성input', {
                label: label,
              }),
          option: {
            type: 'error',
          },
        });
      }
      setValue(inputValue);
    }
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => handleOnChange(newValue)}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) =>
          handleOnInputChange(newInputValue)
        }
        onClose={(e, reason) => handleOnClose(reason)}
        options={options}
        renderInput={(params) => (
          <TextField {...params} label={label} variant="outlined" />
        )}
        classes={{
          root: classes.comboBoxRoot,
        }}
        className={clsx(type === 'filter' && classes.filterSize, className)}
        size="small"
        autoComplete
        loading={options.length === 0}
        loadingText="list loading..."
        {...rest}
      />
    </div>
  );
};
export default NewAutoComplete;
